<h2>
	{{ "client.access.title" | translate }}
</h2>
<mat-card class="sdp-access-card">
	<div class="sdp-row-with-buttons-container">
		<div>
			<h4>{{ "client.access.section.1.header" | translate }}</h4>
			<div>
				{{ "client.access.section.1.body" | translate }}
			</div>
		</div>
		<div>
			<a
				href="{{this.downloadUrl}}"
				target="_blank"
				mat-raised-button
				color="accent"
			>
				<sdp-icon [icon]="downloadIcon"></sdp-icon>
				{{ "client.access.section.1.download.text" | translate }}
			</a>
		</div>
	</div>
</mat-card>
<div class="sdp-vertical-spacer"></div>
<mat-card>
	<div class="sdp-row-with-buttons-container">
		<div>
			<h4>{{ "client.access.section.2.header" | translate }}</h4>
			<div [innerHtml]="inviteOthersText"></div>
		</div>
		<div>
			<a
				mat-raised-button
				color="accent"
				href="{{this.emailUrl}}"
			>
				<sdp-icon [icon]="emailIcon"></sdp-icon>
				{{ "client.access.section.2.invite.text" | translate }}
			</a>
			<div class="sdp-access-button-seperator"></div>
			<button
				mat-raised-button
				color="accent"
				ngxClipboard
				[cbContent]="emailBody"
				(cbOnSuccess)="copied()"
			>
				<sdp-icon [icon]="copyIcon"></sdp-icon>
				{{ "client.access.section.2.copy.text" | translate }}
			</button>
		</div>
	</div>
</mat-card>